var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzambelanJednostkiInne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M126.4 58.667H67.2v-16h16a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4H44.8a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h16v16H1.6a1.6 1.6 0 0 0-1.6 1.6v3.2a1.6 1.6 0 0 0 1.6 1.6h24v16H12.8a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h32a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4H32v-16h64v16H83.2a6.4 6.4 0 0 0-6.4 6.4v19.2a6.4 6.4 0 0 0 6.4 6.4h32a6.4 6.4 0 0 0 6.4-6.4v-19.2a6.4 6.4 0 0 0-6.4-6.4h-12.8v-16h24a1.6 1.6 0 0 0 1.6-1.6v-3.2a1.6 1.6 0 0 0-1.6-1.6zm-81.6 28.8v19.2h-32v-19.2h32zm0-51.2v-19.2h38.4v19.2H44.8zm70.4 51.2v19.2h-32v-19.2h32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 8,
    d: "M0 116c0 64.065 51.935 116 116 116s116-51.935 116-116S180.065 0 116 0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.384,
    transform: "translate(52 52)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.38,
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzambelanJednostkiInne);
export default __webpack_public_path__ + "static/media/szambelan_jednostki_inne.d2d14102bc500b03ab92c69aad0644dd.svg";
export { ForwardRef as ReactComponent };